// extracted by mini-css-extract-plugin
export default {"phapLy__header":"phaply_phapLy__header__c8i7n","phapLy__layer":"phaply_phapLy__layer__raFsK","phapLy__body":"phaply_phapLy__body__Txx7I"};